(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-recommendations]').forEach(function (section) {
    if (section.classList.contains('is-ready') || section.dataset.loading === 'true') return;

    function loadRecommendations() {
      section.dataset.loading = 'true';
      fetch(section.dataset.url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = text;
          var source = wrapper.querySelector('[data-product-recommendations]');
          if (!source || source.dataset.hasRecommendations !== 'true') return;
          section.innerHTML = source.innerHTML;
          section.classList.add('is-ready');
          document.dispatchEvent(new CustomEvent('product-recommendations:loaded'));
        })
        .catch(function () {
          section.dataset.loading = 'false';
        });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        loadRecommendations();
      }, { rootMargin: '0px 0px 300px 0px' });
      observer.observe(section);
    } else {
      loadRecommendations();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
